// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__IGsWV","list":"PatternAutocomplete_list__y_8Dq"};